import {
  IEstablishment,
  IEstablishmentRequest,
  IEstablishmentType,
  IMenhirEstablishment,
  IMenhirEstablishmentRequest,
  IMenhirEstablishmentType,
} from '@/common/integrations/menhir/employee/establishments/establishments.types';
import { IMenhirPaginationResponse } from '@/common/types/menhir/general';

export const transformEstablishmentType = (
  menhirEstablishmentType: IMenhirEstablishmentType
): IEstablishmentType => ({
  id: menhirEstablishmentType.id,
  name: menhirEstablishmentType.name,
  description: menhirEstablishmentType.description,
  slug: menhirEstablishmentType.slug,
});

export const transformEstablishment = (
  menhirEstablishment: IMenhirEstablishment
): IEstablishment => {
  const menhirAddress = menhirEstablishment.addresses.find(
    (address) => address.type === 'mailing'
  );
  return {
    id: menhirEstablishment.id,
    name: menhirEstablishment.name,
    address: {
      addressLine1: menhirAddress?.address_line_1 ?? '',
      addressLine2: menhirAddress?.address_line_2,
      zipCode: menhirAddress?.zipcode ?? '',
      city: menhirAddress?.city ?? '',
      country: menhirAddress?.country ?? '',
      type: menhirAddress?.type,
    },
    types: menhirEstablishment.types.map(transformEstablishmentType),
    logo: menhirEstablishment.logo_url,
    website: menhirEstablishment.website_url,
    description: menhirEstablishment.description,
  };
};

export const transformEstablishmentList = (
  response: IMenhirPaginationResponse<IMenhirEstablishment>
): IEstablishment[] => response.list.map(transformEstablishment);

export const transformEstablishmentRequest = (
  menhirEstablishmentRequest: IMenhirEstablishmentRequest
): IEstablishmentRequest => ({
  status: menhirEstablishmentRequest.status,
  phone: menhirEstablishmentRequest.phone,
  name: menhirEstablishmentRequest.name,
  establishmentType: {
    slug: menhirEstablishmentRequest.establishment_type.slug,
    name: menhirEstablishmentRequest.establishment_type.name,
    description: menhirEstablishmentRequest.establishment_type.description,
  },
  email: menhirEstablishmentRequest.email,
  contactName: menhirEstablishmentRequest.contact_name,
});
